import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1
};
import { watch } from "vue";
import { useOverlayStore } from "./stores";
import { configuratorOpenState } from "@/stores/configuratorOpenState";
import OpenConfigurator from "./components/OpenConfigurator.vue";
import OpenConfiguratorModel from "./components/OpenConfiguratorModel.vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    const overlayStore = useOverlayStore();
    const cos = configuratorOpenState();
    watch(cos, nV => {
      if (nV.open === true) {
        overlayStore.toggleOverlay();
        cos.setOpen(false);
        document.documentElement.classList.add("konfig-popup-hidden");
        document.body.classList.add("wika-dialog-open");
      }
      if (nV.model === true) {
        overlayStore.toggleModelOverlay();
      }
    }, {
      deep: true,
      immediate: true
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_unref(overlayStore).isVisible ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(OpenConfigurator)])) : _createCommentVNode("", true), _unref(overlayStore).isModelVisible ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(OpenConfiguratorModel)])) : _createCommentVNode("", true)], 64);
    };
  }
});